// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DQRule
 */
export interface DQRule {
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    column?: string | null;
    /**
     * Column names for IsPrimaryKey rule
     * @type {Array<string>}
     * @memberof DQRule
     */
    columns?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof DQRule
     */
    confidence?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    dataType?: string | null;
    /**
     * Days threshold for ColumnValues in last N days
     * @type {number}
     * @memberof DQRule
     */
    days?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DQRule
     */
    enabled?: boolean;
    /**
     * Maximum value for range checks
     * @type {number}
     * @memberof DQRule
     */
    max?: number | null;
    /**
     * Minimum value for range checks
     * @type {number}
     * @memberof DQRule
     */
    min?: number | null;
    /**
     * Pattern for ColumnValues matches
     * @type {string}
     * @memberof DQRule
     */
    pattern?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    reasoning?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    rule_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    source_reference?: string | null;
    /**
     * SQL expression for CustomSql rules
     * @type {string}
     * @memberof DQRule
     */
    sql?: string | null;
    /**
     * Completeness threshold as a 0-1 ratio
     * @type {number}
     * @memberof DQRule
     */
    threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof DQRule
     */
    type: string;
    /**
     * WHERE clause for conditional rules
     * @type {string}
     * @memberof DQRule
     */
    where?: string | null;
}

/**
 * Check if a given object implements the DQRule interface.
 */
export function instanceOfDQRule(value: object): value is DQRule {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function DQRuleFromJSON(json: any): DQRule {
    return DQRuleFromJSONTyped(json, false);
}

export function DQRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DQRule {
    if (json == null) {
        return json;
    }
    return {
        
        'column': json['column'] == null ? undefined : json['column'],
        'columns': json['columns'] == null ? undefined : json['columns'],
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'dataType': json['dataType'] == null ? undefined : json['dataType'],
        'days': json['days'] == null ? undefined : json['days'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'pattern': json['pattern'] == null ? undefined : json['pattern'],
        'reasoning': json['reasoning'] == null ? undefined : json['reasoning'],
        'rule_name': json['rule_name'] == null ? undefined : json['rule_name'],
        'source': json['source'] == null ? undefined : json['source'],
        'source_reference': json['source_reference'] == null ? undefined : json['source_reference'],
        'sql': json['sql'] == null ? undefined : json['sql'],
        'threshold': json['threshold'] == null ? undefined : json['threshold'],
        'type': json['type'],
        'where': json['where'] == null ? undefined : json['where'],
    };
}

export function DQRuleToJSON(json: any): DQRule {
    return DQRuleToJSONTyped(json, false);
}

export function DQRuleToJSONTyped(value?: DQRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'column': value['column'],
        'columns': value['columns'],
        'confidence': value['confidence'],
        'dataType': value['dataType'],
        'days': value['days'],
        'enabled': value['enabled'],
        'max': value['max'],
        'min': value['min'],
        'pattern': value['pattern'],
        'reasoning': value['reasoning'],
        'rule_name': value['rule_name'],
        'source': value['source'],
        'source_reference': value['source_reference'],
        'sql': value['sql'],
        'threshold': value['threshold'],
        'type': value['type'],
        'where': value['where'],
    };
}
